import React, { useEffect, useRef } from "react";
import { Grid, TextField, Button, FormControl, makeStyles } from "@material-ui/core";
import DateField from "../DateField";

const useStyles = makeStyles((theme) => ({
  filterBar: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  formControl: {
    width: "100%",
  },
  dateField: {
    [theme.breakpoints.up("md")]: {
      width: 170,
    },
  },
}));

const searchDelay = 500;

export const blankTransactionFilters = {
  dateFrom: "",
  dateTo: "",
  accounts: "",
  chequeNo: "",
  chequeBank: "",
  narration: "",
  amount: "",
};

function TransactionFilters({
  filters,
  onChange,
  onSearch,
  onClear,
  showAccounts = true,
  showChequeNo = true,
  showChequeBank = true,
  showNarration = true,
  showAmount = true,
}) {
  const classes = useStyles();
  const onSearchRef = useRef(onSearch);
  const isFirstRender = useRef(true);
  onSearchRef.current = onSearch;

  // Search once the user stops typing
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => onSearchRef.current(), searchDelay);
    return () => clearTimeout(timer);
  }, [filters]);

  function handleKeyUp(e) {
    if (e.keyCode === 13) onSearch();
  }

  return (
    <Grid container spacing={2} alignItems="center" className={classes.filterBar}>
      <Grid item xs={6} sm={3} md="auto">
        <FormControl className={`${classes.formControl} ${classes.dateField}`}>
          <DateField
            label="From Date"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={filters.dateFrom}
            onChange={(value) => onChange("dateFrom", value)}
            onKeyUp={handleKeyUp}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={3} md="auto">
        <FormControl className={`${classes.formControl} ${classes.dateField}`}>
          <DateField
            label="To Date"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={filters.dateTo}
            onChange={(value) => onChange("dateTo", value)}
            onKeyUp={handleKeyUp}
          />
        </FormControl>
      </Grid>
      {showAccounts && (
        <Grid item xs={6} sm={3} md>
          <FormControl className={classes.formControl}>
            <TextField
              label="Accounts"
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={filters.accounts}
              onChange={(e) => onChange("accounts", e.target.value)}
              onKeyUp={handleKeyUp}
            />
          </FormControl>
        </Grid>
      )}
      {showChequeNo && (
        <Grid item xs={6} sm={3} md>
          <FormControl className={classes.formControl}>
            <TextField
              label="Cheque No"
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={filters.chequeNo}
              onChange={(e) => onChange("chequeNo", e.target.value)}
              onKeyUp={handleKeyUp}
            />
          </FormControl>
        </Grid>
      )}
      {showChequeBank && (
        <Grid item xs={6} sm={3} md>
          <FormControl className={classes.formControl}>
            <TextField
              label="Member Bank"
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={filters.chequeBank}
              onChange={(e) => onChange("chequeBank", e.target.value)}
              onKeyUp={handleKeyUp}
            />
          </FormControl>
        </Grid>
      )}
      {showNarration && (
        <Grid item xs={6} sm={3} md>
          <FormControl className={classes.formControl}>
            <TextField
              label="Narration"
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={filters.narration}
              onChange={(e) => onChange("narration", e.target.value)}
              onKeyUp={handleKeyUp}
            />
          </FormControl>
        </Grid>
      )}
      {showAmount && (
        <Grid item xs={6} sm={3} md>
          <FormControl className={classes.formControl}>
            <TextField
              label="Amount"
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={filters.amount}
              onChange={(e) => onChange("amount", e.target.value)}
              onKeyUp={handleKeyUp}
            />
          </FormControl>
        </Grid>
      )}
      <Grid item xs={12} sm={6} md="auto">
        <Button variant="outlined" size="small" onClick={onClear}>
          Clear
        </Button>
      </Grid>
    </Grid>
  );
}

export default TransactionFilters;
